import CaPersonalDevelopment from "@/components/icons/CaPersonalDevelopment.tsx";
import CaCreativeArts from "@/components/icons/CaCreativeArts.tsx";
import CaHealthAndWellness from "@/components/icons/CaHealthAndWellness.tsx";
import CaLearningAndEducation from "@/components/icons/CaLearningAndEducation.tsx";
import CaScienceAndTechnology from "@/components/icons/CaScienceAndTechnology.tsx";
import CaEnvironmentAndNatureAwareness from "@/components/icons/CaEnvironmentAndNatureAwareness.tsx";
import CaGlobalIssues from "@/components/icons/CaGlobalIssues.tsx";
import CaBusinessAndEconomics from "@/components/icons/CaBusinessAndEconomics.tsx";
import CaLifestyleAndPersonalInterests from "@/components/icons/CaLifestyleAndPersonalInterests.tsx";
import CaRelationshipsAndFamily from "@/components/icons/CaRelationshipsAndFamily.tsx";
import CaLifeSkills from "@/components/icons/CaLifeSkills.tsx";
import CaSocialIssuesAndPolitics from "@/components/icons/CaSocialIssuesAndPolitics.tsx";

export interface Option {
  key: string;
  icon: JSX.Element;
  text: string;
}

export const options: Option[] = [
  {
    key: "personalDevelopment",
    icon: <CaPersonalDevelopment />,
    text: "Personal development",
  },
  {
    key: "creativeArtsAndHobbies",
    icon: <CaCreativeArts />,
    text: "Creative Arts and Hobbies",
  },
  {
    key: "healthAndWellness",
    icon: <CaHealthAndWellness />,
    text: "Health and wellness",
  },
  {
    key: "learningAndEducation",
    icon: <CaLearningAndEducation />,
    text: "Learning and education",
  },
  {
    key: "scienceAndTechnology",
    icon: <CaScienceAndTechnology />,
    text: "Science and technology",
  },
  {
    key: "environmentAndNatureAwareness",
    icon: <CaEnvironmentAndNatureAwareness />,
    text: "Environmental and nature awareness",
  },
  { key: "globalIssues", icon: <CaGlobalIssues />, text: "Global issues" },
  {
    key: "businessAndEconomics",
    icon: <CaBusinessAndEconomics />,
    text: "Business and economics",
  },
  {
    key: "lifestyleAndPersonalInterests",
    icon: <CaLifestyleAndPersonalInterests />,
    text: "Lifestyle and personal interests",
  },
  {
    key: "relationshipsAndFamily",
    icon: <CaRelationshipsAndFamily />,
    text: "Relationships and family",
  },
  { key: "lifeSkills", icon: <CaLifeSkills />, text: "Life skills" },
  {
    key: "socialIssuesAndPolitics",
    icon: <CaSocialIssuesAndPolitics />,
    text: "Social issues and politics",
  },
];

export interface Topic {
  complete: number;
  title: string;
}

export interface TopicWithId {
  id: number;
  complete: number;
  title: string;
}

export type Topics = {
  [x: string]: Topic[];
};
export interface TopicsWithId {
  personalDevelopment: TopicWithId[];
  creativeArtsAndHobbies: TopicWithId[];
  healthAndWellness: TopicWithId[];
  learningAndEducation: TopicWithId[];
  scienceAndTechnology: TopicWithId[];
  environmentAndNatureAwareness: TopicWithId[];
  globalIssues: TopicWithId[];
  businessAndEconomics: TopicWithId[];
  lifestyleAndPersonalInterests: TopicWithId[];
  relationshipsAndFamily: TopicWithId[];
  lifeSkills: TopicWithId[];
  socialIssuesAndPolitics: TopicWithId[];
}

export const topics: Topics = {
  personalDevelopment: [
    { complete: 0, title: "Handling stress and challenges" },
    { complete: 0, title: "Mindfulness and personal growth" },
    { complete: 0, title: "Time management" },
    { complete: 0, title: "Your daily routine" },
    { complete: 0, title: "Your goals, aspirations, and bucket list" },
  ],
  creativeArtsAndHobbies: [
    { complete: 0, title: "Art and creativity" },
    { complete: 0, title: "Books" },
    { complete: 0, title: "Cinema and TV series" },
    { complete: 0, title: "Hobbies and pastimes" },
    { complete: 0, title: "Music" },
  ],
  healthAndWellness: [
    { complete: 0, title: "Good and bad habits" },
    { complete: 0, title: "Health and wellness" },
    { complete: 0, title: "Mental health" },
    { complete: 0, title: "Sleep and dreams" },
    { complete: 0, title: "Sports and fitness" },
  ],
  learningAndEducation: [
    { complete: 0, title: "Digital literacy and online safety" },
    { complete: 0, title: "Discussing historical events" },
    { complete: 0, title: "Education" },
    { complete: 0, title: "Learning a new language" },
    { complete: 0, title: "Memory techniques for better studying" },
  ],
  scienceAndTechnology: [
    { complete: 0, title: "Gaming" },
    { complete: 0, title: "Innovation and technology" },
    { complete: 0, title: "Science" },
    { complete: 0, title: "Space" },
    { complete: 0, title: "Your views on artificial intelligence" },
  ],
  environmentAndNatureAwareness: [
    { complete: 0, title: "Climate change" },
    { complete: 0, title: "Nature and wildlife" },
    { complete: 0, title: "Pets and animal companions" },
    { complete: 0, title: "Sustainable living and eco-friendly practices" },
    { complete: 0, title: "The environment" },
  ],
  globalIssues: [
    { complete: 0, title: "Current affairs" },
    { complete: 0, title: "Festivals" },
    { complete: 0, title: "Globalization" },
    { complete: 0, title: "Social media and its impact" },
    { complete: 0, title: "The importance of volunteering" },
  ],
  businessAndEconomics: [
    { complete: 0, title: "Economics" },
    { complete: 0, title: "Entrepreneurial ideas and innovation" },
    { complete: 0, title: "Finance" },
    { complete: 0, title: "Human resources" },
    { complete: 0, title: "Marketing and advertising" },
  ],
  lifestyleAndPersonalInterests: [
    { complete: 0, title: "Cars and motorcycles" },
    { complete: 0, title: "Cuisine and cooking preferences" },
    { complete: 0, title: "Fashion and beauty" },
    { complete: 0, title: "Shopping" },
    { complete: 0, title: "Travel" },
  ],
  relationshipsAndFamily: [
    { complete: 0, title: "Effective communication skills" },
    { complete: 0, title: "Family dynamics and relationships" },
    { complete: 0, title: "Leaders and role models" },
    { complete: 0, title: "Personality traits" },
    { complete: 0, title: "Social etiquette and manners" },
  ],
  lifeSkills: [
    { complete: 0, title: "Critical thinking" },
    { complete: 0, title: "Job interviews" },
    { complete: 0, title: "Negotiation skills" },
    { complete: 0, title: "Personal financial literacy" },
    { complete: 0, title: "Skills, vocation, and talent" },
  ],
  socialIssuesAndPolitics: [
    { complete: 0, title: "Discrimination and human rights" },
    { complete: 0, title: "Gender equality" },
    { complete: 0, title: "Pandemics and their effects" },
    { complete: 0, title: "Politics" },
    { complete: 0, title: "Social issues" },
  ],
};

export const topicsId: TopicsWithId = {
  personalDevelopment: [
    { id: 675, complete: 0, title: "Handling stress and challenges" },
    { id: 676, complete: 0, title: "Mindfulness and personal growth" },
    { id: 677, complete: 0, title: "Time management" },
    { id: 678, complete: 0, title: "Your daily routine" },
    { id: 679, complete: 0, title: "Your goals, aspirations, and bucket list" },
  ],
  creativeArtsAndHobbies: [
    { id: 680, complete: 0, title: "Art and creativity" },
    { id: 681, complete: 0, title: "Books" },
    { id: 682, complete: 0, title: "Cinema and TV series" },
    { id: 683, complete: 0, title: "Hobbies and pastimes" },
    { id: 684, complete: 0, title: "Music" },
  ],
  healthAndWellness: [
    { id: 688, complete: 0, title: "Good and bad habits" },
    { id: 689, complete: 0, title: "Health and wellness" },
    { id: 692, complete: 0, title: "Mental health" },
    { id: 693, complete: 0, title: "Sleep and dreams" },
    { id: 694, complete: 0, title: "Sports and fitness" },
  ],
  learningAndEducation: [
    { id: 685, complete: 0, title: "Digital literacy and online safety" },
    { id: 686, complete: 0, title: "Discussing historical events" },
    { id: 687, complete: 0, title: "Education" },
    { id: 690, complete: 0, title: "Learning a new language" },
    { id: 691, complete: 0, title: "Memory techniques for better studying" },
  ],
  scienceAndTechnology: [
    { id: 661, complete: 0, title: "Gaming" },
    { id: 664, complete: 0, title: "Innovation and technology" },
    { id: 668, complete: 0, title: "Science" },
    { id: 670, complete: 0, title: "Space" },
    { id: 674, complete: 0, title: "Your views on artificial intelligence" },
  ],
  environmentAndNatureAwareness: [
    { id: 655, complete: 0, title: "Climate change" },
    { id: 666, complete: 0, title: "Nature and wildlife" },
    { id: 667, complete: 0, title: "Pets and animal companions" },
    {
      id: 671,
      complete: 0,
      title: "Sustainable living and eco-friendly practices",
    },
    { id: 672, complete: 0, title: "The environment" },
  ],
  globalIssues: [
    { id: 656, complete: 0, title: "Current affairs" },
    { id: 659, complete: 0, title: "Festivals" },
    { id: 662, complete: 0, title: "Globalization" },
    { id: 669, complete: 0, title: "Social media and its impact" },
    { id: 673, complete: 0, title: "The importance of volunteering" },
  ],
  businessAndEconomics: [
    { id: 657, complete: 0, title: "Economics" },
    { id: 658, complete: 0, title: "Entrepreneurial ideas and innovation" },
    { id: 660, complete: 0, title: "Finance" },
    { id: 824, complete: 0, title: "Human resources" },
    { id: 665, complete: 0, title: "Marketing and advertising" },
  ],
  lifestyleAndPersonalInterests: [
    { id: 731, complete: 0, title: "Cars and motorcycles" },
    { id: 732, complete: 0, title: "Cuisine and cooking preferences" },
    { id: 733, complete: 0, title: "Fashion and beauty" },
    { id: 734, complete: 0, title: "Shopping" },
    { id: 735, complete: 0, title: "Travel" },
  ],
  relationshipsAndFamily: [
    { id: 746, complete: 0, title: "Effective communication skills" },
    { id: 747, complete: 0, title: "Family dynamics and relationships" },
    { id: 748, complete: 0, title: "Leaders and role models" },
    { id: 749, complete: 0, title: "Personality traits" },
    { id: 750, complete: 0, title: "Social etiquette and manners" },
  ],
  lifeSkills: [
    { id: 826, complete: 0, title: "Critical thinking" },
    { id: 827, complete: 0, title: "Job interviews" },
    { id: 828, complete: 0, title: "Negotiation skills" },
    { id: 829, complete: 0, title: "Personal financial literacy" },
    { id: 830, complete: 0, title: "Skills, vocation, and talent" },
  ],
  socialIssuesAndPolitics: [
    { id: 835, complete: 0, title: "Discrimination and human rights" },
    { id: 834, complete: 0, title: "Gender equality" },
    { id: 833, complete: 0, title: "Pandemics and their effects" },
    { id: 832, complete: 0, title: "Politics" },
    { id: 831, complete: 0, title: "Social issues" },
  ],
};
